import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteCircle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7,
			stroke: "#AAAAAA",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AAAAAA",
			d: "M9.9425 5L8 6.9425L6.0575 5L5 6.0575L6.9425 8L5 9.9425L6.0575 11L8 9.0575L9.9425 11L11 9.9425L9.0575 8L11 6.0575L9.9425 5Z"
		})
	]
});
const ForwardRef = forwardRef(SvgDeleteCircle);
export default ForwardRef;
